<template>
  <div>
    <div v-for="(message, index) in messages" :key="index">
      <p style="font-size: 16px; line-height: 24px; text-align: center">
        {{
          index.toString() == new Date().toISOString().slice(0, 10)
            ? "Today"
            : index.toString() ==
              new Date().getFullYear +
                "-" +
                String(new Date().getMonth() + 1).padStart(2, "0") +
                "-" +
                String(new Date().getDate() - 1).padStart(2, "0")
            ? "Yesterday"
            : new Date(index.toString()).getDate() +
              " " +
              new Date(index.toString()).toLocaleDateString("en-us", {
                month: "long",
              }) +
              (new Date().getFullYear == new Date(index.toString()).getFullYear
                ? ""
                : " " + new Date(index.toString()).getFullYear)
        }}
      </p>
      <message-list-item
        v-for="item in message"
        :message="item"
        :key="item.id"
      />
    </div>
  </div>
</template>

<script>
import MessageListItem from "./MessageListItem";

export default {
  name: "MessageList",
  components: { MessageListItem },
  props: ["messages"],
};
</script>

<style scoped></style>
